module.exports = __webpack_public_path__ + "static/img/5.f4925c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/5.png
// module id = 7YlJ
// module chunks = 1